import React from 'react';
import Admin from './AdminConsole';
import { ModuleProps } from 'types';
import getRoutes from './routes';
import RouteModuleFactory from '../@layout/Router/RouteModuleFactory';
import { RouteProps } from 'react-router-dom';

const routes = getRoutes();

const AdminModule: React.FC<ModuleProps> = moduleProps => {
  return (
    <RouteModuleFactory
      IndexComponent={(props: RouteProps): JSX.Element => <Admin {...props} {...moduleProps} />}
      routes={routes}
      {...moduleProps}
    />
  );
};

export default AdminModule;
